import React from 'react';
import classNames from 'classnames';
import usePlayersContext from "../hooks/usePlayersContext";

const EmbedButton = () => {
    const { closeAllPopups, showPopupEmbed, popupEmbed } = usePlayersContext();
    const btnClass = classNames('player-app__btn', 'episode-player-embed', {
        'episode-player-active': showPopupEmbed,
    });
    return (
        <button
            onClick={() => {
                closeAllPopups();
                popupEmbed();
            }}
            className={btnClass}
            aria-label="Embed"
        >
            <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.334 10.3333L14.6673 7L11.334 3.66667M4.66732 3.66667L1.33398 7L4.66732 10.3333M9.33398 1L6.66732 13" stroke="#321A51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    );
};

export default EmbedButton;
